export const ERP_DRIVEN_PRIMARY_ADDRESS_VALUE = '.';
